import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VatTuDetailModal = _resolveComponent("VatTuDetailModal")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_VatTuTable = _resolveComponent("VatTuTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VatTuDetailModal, {
      "vat-tu-id": _ctx.selectedVatTuId,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedVatTuId = undefined)),
      onRefresh: _cache[1] || (_cache[1] = 
      () => {
        _ctx.selectedVatTuId = undefined;
        _ctx.$emit('refresh');
      }
    )
    }, null, 8, ["vat-tu-id"]),
    _createVNode(_component_VatTuTable, {
      "cell-class-name": _ctx.isTextDangerColumn,
      "cur-page": _ctx.curPage,
      "is-loading": _ctx.isLoading,
      items: _ctx.vatTuItems,
      "per-page": _ctx.perPage,
      "use-pagination-index": true,
      "empty-text": "Chưa có vật tư",
      "max-height": "800"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          width: "60",
          align: "center",
          "header-align": "center",
          label: "Thu hồi"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.vatTuItems[scope.$index].thu_hoi,
              "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].thu_hoi) = $event),
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "60",
          align: "center",
          "header-align": "center",
          label: "C/ty quản lý"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.vatTuItems[scope.$index].cong_ty_duyet,
              "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].cong_ty_duyet) = $event),
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: _ctx.columnWidths.soLuong,
          align: "right",
          "header-align": "center",
          label: "S/lượng HĐ"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.formatQuantity(scope.row.so_luong_trong_hop_dong)), 1)
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_table_column, {
          width: _ctx.columnWidths.soLuong,
          align: "center",
          "header-align": "center",
          label: "SLthiếu"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.so_luong_thieu === 0 ? 'success' : 'danger',
              class: "hop-dong-vat-tu-table__sl-thieu-tag",
              "disable-transitions": "",
              effect: "dark"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formatQuantity(+scope.row.so_luong_thieu)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_table_column, {
          width: _ctx.columnWidths.donGia,
          align: "right",
          "header-align": "center",
          label: "Đơn giá"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.formatUnitPrice(scope.row.don_gia)), 1)
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_table_column, {
          width: _ctx.columnWidths.thanhTien,
          align: "right",
          "header-align": "center",
          label: "Thành tiền"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.formatAmount(
            _ctx.calcLineAmount(scope.row.don_gia, scope.row.so_luong_trong_hop_dong)
          )), 1)
          ]),
          _: 1
        }, 8, ["width"]),
        (_ctx.vatTuItems.length)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              fixed: "right",
              width: _ctx.columnWidths.actions,
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_Setting, {
                  actions: _ctx.getSettingActions(scope.row)
                }, null, 8, ["actions"])
              ]),
              _: 1
            }, 8, ["width"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["cell-class-name", "cur-page", "is-loading", "items", "per-page"])
  ], 64))
}